export default __webpack_public_path__ + "static/media/service-family-gray-empty.8fab80d5.svg";